<template>
  <div class="main">
    <div class="container pt-x4">
      <div class="mobile-logo-container">
        <img class="mobile-logo" src="/images/logo@2x.png">
      </div>
      <div class="row mb-x4">
        <div class="col">
          <h3><img class="heading-logo" src="/images/logo@2x.png">Login</h3>
            <p>
              Please enter login info below to continue
            </p>
        </div>
      </div>
      <div class="row mb-x2" v-if="loginError">
        <div class="col">
          <div class="zero-notification uhoh">
            <div class="zero-notification-icon"></div>
            Incorrect login credentials. Please try again.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-10 col-md-6 col-ld-4 zero-form">
          <div class="input-block">
            <label for="user-email">
              email
            </label>
            <input
              type="email"
              id="user-email"
              name="user-email"
              placeholder=""
              class="standard-text-input"
              v-model="userEmail"
              :class="{ 'has-error': emailError }"
            >
            <p class="input-error" v-if="emailError">
              Please enter your email address
            </p>
          </div>
          <div class="input-block">
            <label for="user-email">
              password
            </label>
            <input
              type="password"
              id="user-password"
              name="user-password"
              placeholder=""
              class="standard-text-input"
              v-model="userPW"
              :class="{ 'has-error': pwError }"
              autocomplete="off"
              @keyup.enter="login()"
            >
            <div class="input-prefix clickable" @click="togglePW()">
              <i class="fas fa-eye" v-if="hidePW"></i>
              <i class="fas fa-eye-slash" v-else></i>
            </div>
            <p class="input-error" v-if="pwError">
              Please enter your password
            </p>
          </div>
        </div>
      </div>
      <div class="row mb-x8">
        <div class="col">
          <button class="zero-btn zero-btn-standard zero-btn-primary mr-x4" @click="login()">
            Login
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

const axios = require('axios')

// endpoint switcher
const apiChoice = process.env.VUE_APP_API_URL

// cookie commands
// this.$cookies.set('name', 'value', null, null, null, true, 'Lax') - true sets secure, Lax sets same-site
// this.$cookies.isKey('cookiename') - checks if cookie is set
// this.$cookies.get("token")
// this.$cookies.remove('usertoken')

export default {
  name: 'home',
  components: {},
  data () {
    return {
      isLoading: false,
      userEmail: '',
      userPW: '',
      emailError: false,
      pwError: false,
      token: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      loginError: false,
      hidePW: true
    }
  },
  created () {
    // check on a cookie
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.$router.push({ path: '/' })
    }
  },
  methods: {
    login () {
      this.emailError = false
      this.pwError = false
      if (!this.userEmail || !this.userPW) {
        if (!this.userEmail) {
          this.emailError = true
        }
        if (!this.userPW) {
          this.pwError = true
        }
      } else {
        let payload = {
          'email': this.userEmail,
          'password': this.userPW
        }
        axios
          .post(apiChoice + 'auth/login', payload, {
            headers: {
              'Cache-Control': 'no-cache'
            }
          })
          .then((response) => {
            // process token
            let parts = response.data.token.split('.')
            this.$cookies.set('j', parts[0], '5d', null, null, true, 'Lax')
            this.$cookies.set('w', parts[1], '5d', null, null, true, 'Lax')
            this.$cookies.set('t', parts[2], '5d', null, null, true, 'Lax')
            let user = {
              'id': response.data.user.id,
              'name': response.data.user.name,
              'email': response.data.user.email,
              'userimage': response.data.user.userimage,
              'permissions': response.data.user.permissions
            }
            let userJson = JSON.stringify(user)
            this.$cookies.set('u', userJson, '5d', null, null, true, 'Lax')
            this.$router.push({ path: '/' })
          })
          .catch((error) => {
            console.log('error occurred')
            console.log(error)
            this.loginError = true
            // this.isLoading = false
          })
      }
    },
    togglePW () {
      if (this.hidePW) {
        document.getElementById('user-password').type = 'text'
        this.hidePW = false
      } else {
        document.getElementById('user-password').type = 'password'
        this.hidePW = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}
.heading-logo{
  height: 34px;
  margin-right: 8px;
  display: none;
}
.mobile-logo-container{
  display: flex;
  justify-content: center;
  margin: 32px 0px;
  .mobile-logo{
    height: 50px;
  }
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .heading-logo{
    display: inline-block;
  }
  .mobile-logo-container{
    display: none;
  }
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
